import { createContext, createEffect, onMount, useContext } from "solid-js";
import { createStore } from "solid-js/store";
import { toaster } from "@kobalte/core";
import {
  Toast,
  ToastContent,
  ToastDescription,
  ToastTitle
} from "@/components/shadcn/toast";
import PasswordModal from "../pages/profile/Password";

const AppContext = createContext();

const initialState = {
  snackbars: [],
  headerText: 'Home',
  sidebarState: 0,
  isMobileView: false,
  theme: "system",
  breadcrumbs: []
};

const THEME_STORAGE_KEY = 'vite-ui-theme-admin';

export default function AppProvider(props) {
  const [store, setStore] = createStore(initialState);
  const [modals, setModals] = createStore({ password: false });

  function successToast(message) {
    toaster.show(props => (
      <Toast toastId={props.toastId}>
        <ToastContent>
          <ToastTitle>Toast</ToastTitle>
          {message}
        </ToastContent>
        <ToastProgress />
      </Toast>
    ));
  }

  function setHeaderText(text) {
    setStore(
      "headerText",
      text
    );
  }

  function setSidebarState(state) {
    setStore(
      "sidebarState",
      state
    );
  }

  function setIsMobileView(isView) {
    setStore(
      "isMobileView",
      isView
    );

    const _bodyClass = document.body.classList;
    if (!isView) {
      _bodyClass.remove('sidebar-close');
    } else {
      _bodyClass.add('sidebar-close');
    }
  }

  function toggleMobileSidebar() {
    if (!store.isMobileView) {
      return;
    }

    document.body.classList.add('sidebar-close');
  }

  function successToast(message) {
    toaster.show(props => (
      <Toast toastId={props.toastId}>
        <ToastContent>
          <ToastTitle>Success</ToastTitle>
          <ToastDescription>{message}</ToastDescription>
        </ToastContent>
      </Toast>
    ));
  }

  function errorMessage(message) {
    toaster.show(props => (
      <Toast toastId={props.toastId} variant="destructive">
        <ToastContent>
          <ToastTitle>Uh oh! Something went wrong.</ToastTitle>
          <ToastDescription>{message}</ToastDescription>
        </ToastContent>
      </Toast>
    ));
  }

  function errorToast(error) {
    let message = error;
    if (error.message !== undefined) {
      message = error.message;
    }

    if (error.response === undefined) {
      errorMessage(message);
      return;
    }

    if (error.response.messages === undefined) {
      errorMessage(message);
      return;
    }

    error.response.messages.forEach(msg => {
      errorMessage(msg);
    });
  }

  function openPasswordModal() {
    setModals('password', true);
  }

  function setBreadcrumb(breadcrumbs) {
    setStore("breadcrumbs", breadcrumbs);
  }

  function setNavigationButtons(buttons) {
  }

  function getBreadcrumb() {
    return store.breadcrumbs;
  }

  function setTheme(theme) {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
    setStore("theme", theme);
  }

  createEffect(() => {
    store.theme;

    const root = window.document.documentElement;

    root.classList.remove("light", "dark")

    if (store.theme === "system") {
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)")
        .matches
        ? "dark"
        : "light"

      root.classList.add(systemTheme)
      return
    }

    root.classList.add(store.theme)
  })

  onMount(() => {
    const theme = localStorage.getItem(THEME_STORAGE_KEY);
    if (theme) {
      setStore("theme", theme);
    }
  });

  return (
    <AppContext.Provider
      value={{
        successToast,
        errorToast,
        setHeaderText,
        setBreadcrumb,
        getBreadcrumb,
        setSidebarState,
        setIsMobileView,
        toggleMobileSidebar,
        setNavigationButtons,
        openPasswordModal,
        setTheme,
        theme: () => { return store.theme; }
      }}
    >
      {props.children}
      <PasswordModal open={modals.password} onClose={() => setModals('password', false)} />
    </AppContext.Provider>
  );
}

export const useApplication = () => useContext(AppContext);
